import { Title, Meta } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink} from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { PLATFORM_ID, Inject } from '@angular/core';
import { InspireDeferComponent } from './inspire-defer/inspire-defer.component';
import { OtherDeferComponent } from './other-defer/other-defer.component';
import { SEOService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-verlanglijst',
  templateUrl: './verlanglijst.component.html',
  standalone: true,
  imports: [RouterLink, InspireDeferComponent, OtherDeferComponent]
})
export class VerlanglijstComponent implements OnInit {
  queryParams: any;
  pageParam = false;

  constructor(@Inject(PLATFORM_ID) private platformId: object,
    private userService: UserService, private titleService: Title, private router: Router, private metaTagService: Meta, private seoService: SEOService) {
  }

  ngOnInit() {
    this.seoService.updateCanonicalLink("");
    
    this.queryParams = this.router
      .routerState.root
      .queryParams
      .subscribe((params: any) => {
        if (params.page) {
          this.pageParam = true;
        }


        // Als je bent ingelogd en je navigeert naar de homepage zonder page param dan naar /mijnlijstjes.
        /*
        if (!this.pageParam && this.userService.isLoggedIn()) {

          this.logger.log('door naar mijnlijstjes');
          this.router.navigate(['/mijnlijstjes']);
        }
          */

      });
    this.userService.visitWishList(false);

    this.titleService.setTitle('Verlanglijstje maken en delen anno nu! - Verlanglijst.online');

    this.metaTagService.updateTag({
      name: 'description',
      content: 'Hip en modern verlanglijstje om je wannahaves te delen via WhatsApp, '
        + 'Facebook of via een link. Snel, simpel en gratis.'
    });

    this.metaTagService.updateTag({
      property: 'og:title', content: 'Verlanglijstje maken? | Verlanglijst.online'
    });

    this.metaTagService.updateTag({
      property: 'og:description',
      content: 'Zoek uit wat je leuk vindt en zet het op je verlanglijstje!'
    });

    this.metaTagService.updateTag({
      property: 'og:image', content: 'https://verlanglijst.online/assets/images/share-logo.png'
    });

  }


}
